import InventoryGroupAdministration from './InventoryGroupAdministration'

export default InventoryGroupAdministration
